export default "__VITE_ASSET__BeQtl42u__"